import { SRGBColorSpace, type Camera, type Scene, type WebGLRenderer, type WebGLRenderTarget } from 'three'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'

export default function createEffectComposer(
  scene : Scene,
  camera : Camera,
  renderer : WebGLRenderer,
  renderTarget: WebGLRenderTarget,
): EffectComposer {
  const composer = new EffectComposer(renderer, renderTarget)
  composer.addPass(new RenderPass(scene, camera))

  // composer.renderTarget1.depthTexture = new DepthTexture(window.innerWidth, window.innerHeight)
  // composer.renderTarget2.depthTexture = new DepthTexture(window.innerWidth, window.innerHeight)
  composer.renderTarget1.texture.colorSpace = SRGBColorSpace
  composer.renderTarget2.texture.colorSpace = SRGBColorSpace

  const renderPass = new RenderPass(scene, camera)
  composer.addPass(renderPass)

  // createMountedVisualizeDepthShader(composer, camera, renderTarget)

  // createMountedSaturationShader(composer)
  // createMountedPixelateShader(composer)

  return composer
}
